import { CommentCodeModel, ListResponseModel, QueryParamModel } from 'models';
import { EntityService } from 'utils/entityService';
import request from 'utils/request';

class CommentCodesService extends EntityService {
  constructor() {
    super('reading-comment-code');
  }

  async getCommentCodes(params?: QueryParamModel | null) {
    return request<ListResponseModel<CommentCodeModel>>({
      resource: this.resource,
      params,
    });
  }
}

export const commentCodesService = new CommentCodesService();
